module.exports = __webpack_public_path__ + "static/img/116.ba3e7bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/116.png
// module id = 6r1r
// module chunks = 0